<style lang="less" scoped>
  .preview-box{
    margin-top: 20px;
    border-radius: 5px;
    border: 1px solid #eee;
    box-shadow: 2px 2px 5px #f0f0f0;
    padding: 10px;
  }
</style>

<template>
  <div>
    <div class="preview-box" ref="box" v-show="file">
      <slot></slot>
      <video :src="videosrc" controls width="100%" type="video/mp4">
        您的浏览器不支持 video 标签。
        Internet Explorer 9+, Firefox, Opera, Chrome 以及 Safari 支持 video 标签。
      </video>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      file: {
        type: File,
        required: false
      }
    },
    data() {
      return {
        videosrc:""
      };
    },
    watch: {
      file(v) {
        window.console.log("aaa " + this.videosrc);
        if (!v) {
          return;
        }
        window.console.log("aaa1 " + this.videosrc);
        this.videosrc = URL.createObjectURL(v);
      }
    }
  };
</script>

